import band1 from "../../images/New images/band-1.png";
import band2 from "../../images/New images/band-2.png";
import band3 from "../../images/New images/band-3.png";
import band4 from "../../images/New images/band-4.png";
import band5 from "../../images/New images/band-5.png";
import band6 from "../../images/New images/band-6.png";
import band7 from "../../images/New images/band-7.png";
import band8 from "../../images/New images/band-8.png";
import band9 from "../../images/New images/band-9.png";
import band10 from "../../images/New images/band-10.png";
import band11 from "../../images/New images/band-11.png";
import band12 from "../../images/New images/band-12.png";
import band13 from "../../images/New images/band-13.png";
import band14 from "../../images/New images/band-14.png";
import band15 from "../../images/New images/band-15.png";
import band16 from "../../images/New images/band-16.png";
import band17 from "../../images/New images/band-17.png";
import band18 from "../../images/New images/band-18.png";
import band19 from "../../images/New images/band-19.png";
import band20 from "../../images/New images/band-20.png";
import band21 from "../../images/New images/band-21.png";
import band22 from "../../images/New images/band-22.png";
import band23 from "../../images/New images/band-23.png";
import band24 from "../../images/New images/band-24.png";
import band25 from "../../images/New images/band-25.png";
import band26 from "../../images/New images/band-26.png";
import band27 from "../../images/New images/band-27.png";
import band28 from "../../images/New images/band-28.png";
import band29 from "../../images/New images/band-29.png";
import band30 from "../../images/New images/band-30.png";
import band31 from "../../images/New images/band-31.png";
import band32 from "../../images/New images/band-32.png";
import band33 from "../../images/New images/band-33.png";

const images = [
  { original: band1, thumbnail: band1 },
  { original: band2, thumbnail: band2 },
  { original: band3, thumbnail: band3 },
  { original: band4, thumbnail: band4 },
  { original: band5, thumbnail: band5 },
  { original: band6, thumbnail: band6 },
  { original: band7, thumbnail: band7 },
  { original: band8, thumbnail: band8 },
  { original: band9, thumbnail: band9 },
  { original: band10, thumbnail: band10 },
  { original: band11, thumbnail: band11 },
  { original: band12, thumbnail: band12 },
  { original: band13, thumbnail: band13 },
  { original: band14, thumbnail: band14 },
  { original: band15, thumbnail: band15 },
  { original: band16, thumbnail: band16 },
  { original: band17, thumbnail: band17 },
  { original: band18, thumbnail: band18 },
  { original: band19, thumbnail: band19 },
  { original: band20, thumbnail: band20 },
  { original: band21, thumbnail: band21 },
  { original: band22, thumbnail: band22 },
  { original: band23, thumbnail: band23 },
  { original: band24, thumbnail: band24 },
  { original: band25, thumbnail: band25 },
  { original: band26, thumbnail: band26 },
  { original: band27, thumbnail: band27 },
  { original: band28, thumbnail: band28 },
  { original: band29, thumbnail: band29 },
  { original: band30, thumbnail: band30 },
  { original: band31, thumbnail: band31 },
  { original: band32, thumbnail: band32 },
  { original: band33, thumbnail: band33 },
];

export default images;
